    <div class="my-3 my-md-5">
        <div class="container">
            <div class="page-header">
                <h1 class="page-title">
                    Status Wise Report
                </h1>
            </div>

            <div class="row row-cards" >
                  <div class="col-sm-12 mt-2">
                        <div class="row ">
                            <!-- UserId-3 AdnanId -->
                            <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || userId=='3'">
                                <mat-select  placeholder="Circle" (selectionChange)="getStatusWiseReport()" [(ngModel)]="circle">
                                    <mat-option >All</mat-option>
                                    <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                                </mat-select>
                            </div>
                            <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3' || myrole=='6' || myrole=='15'">
                                <mat-select  placeholder="Bds" (selectionChange)="getStatusWiseReport()" [(ngModel)]="bd_filter" #itemSelect="ngModel">
                                    <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                                </mat-select>
                            </div>
                            <div class="col-sm-4 mt-2" >
                                <mat-select  placeholder="Lead Status" (selectionChange)="getStatusWiseReport()" [(ngModel)]="lead_status" multiple #itemSelect="ngModel">
                                    <div class="btn-group col-sm-12">
                                        <button class="btn btn-primary width50" mat-button (click)="selectAll(itemSelect)">Select All</button>
                                        <button class="btn btn-danger width50" mat-button (click)="deselectAll(itemSelect)">Deselect All</button>
                                      </div>
                                    <mat-option [value]="leadst.id" *ngFor="let leadst of leadStatus">{{leadst.name}}</mat-option>
                                </mat-select>
                            </div>
                            <!-- <div class="col-sm-2 mt-2">
                                <mat-select  placeholder="Catergory wise" (selectionChange)="getStatusWiseReport()" [(ngModel)]="category_filter" *ngIf="treatment_catergory_access=='1' || myrole=='1'">
                                    <mat-option>All</mat-option>
                                    <mat-option value="2">PCLC Team</mat-option>
                                    <mat-option value="3">VODKA Team</mat-option>
                                    <mat-option value="4">Dental Team</mat-option>
                                </mat-select>
                            </div> -->
                            <div class="col-sm-2 mt-2">
                              <mat-select  placeholder="Treatment wise" (selectionChange)="getStatusWiseReport()" [(ngModel)]="treatment_filter">
                                  <mat-option >All</mat-option>
                                  <mat-option [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                              </mat-select>
                            </div>
                            <div class="col-sm-2 mt-2">
                              <mat-select  placeholder="Lead Source" (selectionChange)="getStatusWiseReport()" [(ngModel)]="lead_source_filter">
                                <mat-option >All</mat-option>
                                <mat-option value="2">Kaleyra</mat-option>
                                <mat-option value="1">Forms</mat-option>
                                <mat-option value="3">Practo</mat-option>
                                <mat-option value="4">Consult Now</mat-option>
                                <mat-option value="5">FB/IG</mat-option>
                                <mat-option value="6">Youtube</mat-option>
                                <mat-option value="7">Referral</mat-option>
                                <mat-option value="8">Blogs</mat-option>
                                <mat-option value="9">Medife</mat-option>
                                <mat-option value="10">Google Business Page</mat-option>
                                <mat-option value="11">Form FB/IG</mat-option>
                                <mat-option value="12">Paytm</mat-option>
                                <mat-option value="13">Medife FB</mat-option>
                                <mat-option value="14">Just Dial</mat-option>
                                <mat-option value="15">Taboola</mat-option>
                                <mat-option value="16">Whatsapp</mat-option>
                                <mat-option value="17">Compititor</mat-option>
                                <mat-option value="18">True Cover</mat-option>
                                <mat-option value="19">Paytm</mat-option>
                                <mat-option value="20">Fb-Kalera</mat-option>
                                <mat-option value="21">Wp-Form</mat-option>
                                <mat-option value="22">Brand Fb-Source</mat-option>
                              </mat-select>
                          </div>

                        </div>
                        <div class="row">
                          <div class="col-sm-4 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                          </div>

                          <div class="col-sm-3 mt-2">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" (change)="getStatusWiseReport()" [(ngModel)]="displayFollowUpByLeadDate">
                                <span class="custom-control-label">Display follow up by lead date</span>
                              </label>
                          </div>
                    </div>
                    </div>
                  <div class="col-sm-12">
                      <div class=' card p-0 table-responsive'>
                        <table class="table table-hover table-outline table-vcenter dashtable">
                              <thead>
                                  <tr>
                                      <th></th>
                                      <th>Users</th>
                                      <th class="text-center" *ngFor="let status of allStatus">{{status.name}}</th>
                                      <th class="text-center">Total</th>
                                  </tr>
                              </thead>
                              <tbody>
                                <tr class="box overall" [ngClass]="{'bg-red-lighter':user.id==21}" *ngFor="let user of allUsers">
                                    <td class="text-center">
                                        <div class="avatar d-block" style="background-image: url('https://glamyohealth.in/backend/assets/backend/img/static/admin-avatar.png')">
                                          <span class="avatar-status bg-green"></span>
                                        </div>
                                      </td>
                                      <td>{{user.name}}</td>
                                      <td class="text-center" *ngFor="let ustatus of user.status_count"><span class="">{{ustatus.lead_count}}</span></td>
                                      <td class="text-center"><span class="">{{user.total_count}}</span></td>
                                  </tr>
                                  <tr class="box overall" *ngIf="loading">
                                      <td colspan="30" class="text-center"><i class="fas fa-spin fa-spinner fa-2x"></i></td>
                                  </tr>
                                  <tr class="box overall" *ngIf="loaded && !allUsers.length">
                                      <td colspan="30" class="text-center"> <i class="far fa-frown"></i> No Leads Available</td>
                                  </tr>
                              </tbody>
                        </table>
                      </div>
                  </div>
              </div>

        </div>
    </div>
